import React from 'react'
import { useHistory } from 'react-router-dom'
import { notification } from 'antd'
import { Form } from 'formik-antd'
import {
  VerifyPassportRequest,
  useVerifyPassword,
} from '../../../services/api/auth'
import { useQuery } from '../../../utils/hooks/query'
import { View } from './View'
import { defaultPath } from '../../../routes/paths'

type Form = VerifyPassportRequest

export const Container: React.FunctionComponent = () => {
  const history = useHistory()
  const token = useQuery().get('token')

  if (token === null || token === '') {
    history.push(defaultPath())
    notification.error({
      message: 'Ссылка является недействительной',
      duration: 3,
    })
  }

  const [verifyPassword, { error }] = useVerifyPassword()
  const initialValues: Form = {
    token: token as string,
    password: '',
  }

  const onSubmit = (form: Form) => {
    return verifyPassword(form).then(() => {
      history.push(defaultPath())
      notification.success({
        message: 'Пароль успешно сменен',
        duration: 3,
      })
    })
  }

  return (
    <View error={error} initialValues={initialValues} onSubmit={onSubmit} />
  )
}
